import types from './types';

const INITIAL_STATE = {
    isFetching: false,

    result: [],
};

const authDiagRecordsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_DIAG_RECORDS_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_DIAG_RECORDS_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_DIAG_RECORDS_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    default:
      return state;
  }
};

export default authDiagRecordsReducer;
